<template>
  <section class="section form-section-container">
    <div class="form-header-container">
      <h2 class="header-title">Ready to expand your professional opportunities?</h2>
      <p>
        Complete the form below to join our global talent community and get discovered by companies
        looking for professionals exactly like you!
      </p>
    </div>

    <div class="statement-of-interest-container">
      <h2 class="header-title">Statement of Interest</h2>
      <p>
        📢 Heads-up before you begin. At the end of this form, we'll ask you to self-assess your
        Expertise and Leadership levels using TeamStack's 6-level salary system. This helps us set
        clear expectations for roles, responsibilities, and pay. But don't worry—this is just a
        first indicative assessment, and you can update it later.
      </p>
      <p class="remark">*Indicates mandatory fields</p>
    </div>

    <template v-if="isSubmitted">
      <ThankYouCard />
    </template>
    <template v-else>
      <UserProfileForm @on-success="isSubmitted = true" />
    </template>
  </section>
</template>

<script setup>
import { ref } from "vue";
import ThankYouCard from "@/components/ThankYouCard.vue";
import UserProfileForm from "@/components/forms/UserProfileForm.vue";

const isSubmitted = ref(false);
</script>

<style lang="scss" scoped>
.form-section-container {
  display: flex;
  flex-direction: column;
  gap: 60px;

  .form-header-container {
    margin: 0 auto;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    text-align: center;
    color: #141414;

    p {
      font-family: "Outfit", sans-serif;
      font-weight: 400;
      font-size: 20px;
      line-height: 28px;
    }
  }

  .statement-of-interest-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    padding: 60px;
    border-radius: 24px;
    background: #eee7dd;
    text-align: left;

    @media screen and (max-width: 768px) {
      padding: 32px 16px;
    }

    p,
    .remark {
      color: #141414;
      font-weight: 400;
      font-size: 20px;
      line-height: 28px;
      letter-spacing: 0;
    }

    .remark {
      color: rgba(0, 0, 0, 0.6);
      line-height: 32px;
    }
  }
}
</style>
